import { PATIENT_OPTIONAL_FIELDS } from "./fields";
import type { PatientFieldVisibility } from "./fields";

export type { PatientFieldVisibility };

/** snake_case setting key → the visibility key callers scope the form with. */
const REQUIRED_FIELD_VISIBILITY: Record<string, keyof PatientFieldVisibility> =
  {
    ...Object.fromEntries(
      PATIENT_OPTIONAL_FIELDS.map((field) => [field.requiredKey, field.key]),
    ),
    primary_location: "primaryLocation",
  };

export function isPatientFieldVisible(
  fieldVisibility: PatientFieldVisibility | undefined,
  field: keyof PatientFieldVisibility,
) {
  return fieldVisibility ? fieldVisibility[field] === true : true;
}

export function getVisibleRequiredPatientFields(
  requiredPatientFields: string[] = [],
  fieldVisibility?: PatientFieldVisibility,
) {
  return requiredPatientFields.filter((requiredField) => {
    const visibilityField = REQUIRED_FIELD_VISIBILITY[requiredField];
    if (!visibilityField) return true;

    return isPatientFieldVisible(fieldVisibility, visibilityField);
  });
}
